import React from 'react'

// STYLES
import withAButtonStyles from './button.style'
import cx from 'classnames'

// COMPONENTS
import Button from '@material-ui/core/Button'
import { Pencile } from '../app-icon/Icons'

export const ButtonOutlined = withAButtonStyles(
  ({
    classes,
    className,
    style = {},
    color,
    text,
    handleClick,
    href,
    disabled,
  }) => {
    return (
      <Button
        onClick={handleClick}
        variant="outlined"
        color={color}
        disableRipple={true}
        style={style}
        className={cx(className)}
        classes={{
          root: classes.button,
          outlinedPrimary: classes.primaryOutlined,
          outlinedSecondary: classes.secondaryOutlined,
        }}
        href={href}
        disabled={disabled}
      >
        {text}
      </Button>
    )
  }
)

export const ButtonLink = withAButtonStyles(({ classes, text }) => {
  return (
    <Button
      classes={{
        root: classes.buttonLink,
      }}
    >
      {text}
    </Button>
  )
})

export const ButtonContained = withAButtonStyles(
  ({
    classes,
    id,
    style = {},
    color,
    text,
    type,
    onClick,
    href,
    full,
    disabled,
    customClass,
  }) => {
    return (
      <Button
        variant="contained"
        color={color}
        id={id}
        style={style}
        type={type}
        className={cx(classes.buttonContained, customClass)}
        onClick={onClick}
        href={href}
        fullWidth={full}
        disabled={disabled}
      >
        {text}
      </Button>
    )
  }
)

export const ButtonEdit = withAButtonStyles(
  ({ classes, handleClick, className, style }) => {
    return (
      <button
        type="button"
        style={style}
        className={cx(classes.btnEdit, className)}
        onClick={handleClick}
      >
        <Pencile />
      </button>
    )
  }
)
